import Rails from '@rails/ujs';
import _get from 'lodash/get';

import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['commitInput', 'editor', 'editorErrors', 'railsErrors'];

  connect() {
    this.errors = [];
  }

  submit(event) {
    if (this.editorTargets.length === 0) return;

    this.errors = [];
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // set the commit value according to the button clicked to submit (default to 'save')
    if (this.hasCommitInputTarget) {
      const submitButton = Rails.getData(event.target, 'ujs:submit-button');
      const submitValue = _get(submitButton, 'value', 'save');
      this.commitInputTarget.value = submitValue;
    }

    const allEditorSavePromise = [...this.editorTargets].map((item) => {
      const editorController = this.application.getControllerForElementAndIdentifier(item, 'bo-editor');
      if (editorController) this._save_editor(editorController);
    });


    Promise.all(allEditorSavePromise).then(() => {
      setTimeout(() => {
        // N.B.: as of Chrome 53, untrusted events (not triggered by the user)
        // don't invoke the default action
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted
        // Rails.fire(event.target, 'submit', { propagate: true });

        if (this.errors.length === 0) {
          // compute transports
          const addressContainer = document.querySelector("#container-address-grid-container");
          if (addressContainer) {
            const transportController = this.application.getControllerForElementAndIdentifier(
              addressContainer, 'bo-transport'
            );

            if (transportController.transportTarget.value === "{}") {
              transportController.updateAddress().then(() => event.target.submit());
            } else event.target.submit();
          } else event.target.submit();
        } else {
          this.editorAlert();
        }
      });
    });
  }

  editorAlert() {
    if (!this.editorErrorsTarget) return;

    const errorMessages = this.errors.map((error) => {
      return `<li>${error.title} : ${this._errorMessageRow(error.messages)}</li>`;
    }).join(' ');

    if (this.hasRailsErrorsTarget) {
      this.railsErrorsTarget.querySelector('.editors-errors').innerHTML = errorMessages;
    } else {
      this.editorErrorsTarget.classList.remove('d-none');
      this.editorErrorsTarget.querySelector('ul').innerHTML = `<ul>${errorMessages}</ul>`;
    }

    this._scrollToFeedback();
  }

  // PRIVATE
  _errorMessageRow(messages) {
    return `<ul>${messages.map((message) =>`<li>${message}</li>`).join(' ')}</ul>`;
  }

  _scrollToFeedback() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  _save_editor(editorController) {
    return new Promise((resolve, reject) => {
      editorController
        .save()
        .then((_data) => resolve(_data))
        .catch((error) => {
          if (error.data) {
            const errorData = _get(error, 'data', []);
            this.errors = [...this.errors, ...errorData];
          }

          reject();
        });
    });
  }
}
